import React from 'react'
import useStyles from './ConfirmAccountConfirmationStyles';
import ConfirmAccountConfirmationCard from '@/components/ConfirmAccountConfirmationCard/ConfirmAccountConfirmationCard';

const ConfirmAccountConfirmation: React.FC = () => {

    const { classes, cx } = useStyles();

    React.useEffect(() => {
        window.scroll({ top: 0, left: 0, behavior: 'smooth' })
    }, []);

    return (
        <ConfirmAccountConfirmationCard />
    )
}

export default ConfirmAccountConfirmation
